.chat {
  display: grid;
  width: 100%;
  height: 100%;
  overflow: auto;
}
